<template>
  <GoogleLogin
    class="NavbarBtn btn"
    :params="loginParams"
    :onSuccess="onSuccess"
    :onFailure="onFailure"
    ><img src="../assets/img/google_icon.svg" alt="Google logo" /><span
      >Sign in with Google</span
    ></GoogleLogin
  >
</template>

<script>
import { mapActions } from 'vuex';
import GoogleLogin from 'vue-google-login';

export default {
  name: 'GoogleLoginButton',
  props: {
    setLoading: Function,
    isModal: Boolean,
  },
  components: {
    GoogleLogin,
  },
  data() {
    return {
      loginParams: {
        client_id:
          '728271783455-lqsdn21fscbuu99hitql68qbnl1k9172.apps.googleusercontent.com',
      },
    };
  },
  methods: {
    ...mapActions(['signIn', 'updateIsModalOpened']),
    async onSuccess(googleUser) {
      this.setLoading(true);
      await this.signIn(googleUser);
      this.setLoading(false);
      if (this.isModal) this.updateIsModalOpened(false);
    },
    onFailure(error) {
      console.log(error);
    },
  },
};
</script>

<style lang="scss" scoped>
.NavbarBtn {
  display: flex;
  align-items: center;
  justify-content: center;
  background: $color-white;
  transition: all 0.2s ease-out;
  img {
    width: 18px;
    margin-right: 8px;
  }
  span {
    color: $color-purple;
  }
  &:hover {
    span {
      filter: brightness(120%);
      transition: all 0.2s ease-out;
    }
  }
}

@media screen and (max-width: 650px) {
  .Navbar {
    .NavbarBtn {
      font-size: 15px;
      padding: 15px;
    }
  }
}
</style>
